import { Request } from "./https";

export const Service = {
  get: (params) => {
    const newRequest = new Request("get", `nte-service`, params);
    return newRequest.sendXHR();
  },
};
